export var MmdMesh;
(function (MmdMesh) {
    /**
     * Check if the mesh is MMD mesh
     * @param mesh Mesh to check
     * @returns `true` if the mesh is `MmdMesh`
     */
    function isMmdMesh(mesh) {
        if (mesh.metadata === null || !mesh.metadata.isMmdModel)
            return false;
        if (mesh.material === null || !mesh.material.subMaterials)
            return false;
        for (const material of mesh.material.subMaterials) {
            if (material === null)
                return false;
        }
        if (mesh.skeleton === null)
            return false;
        if (mesh.morphTargetManager === null)
            return false;
        return true;
    }
    MmdMesh.isMmdMesh = isMmdMesh;
    /**
     * Check if the mesh is MMD static mesh
     * @param mesh Mesh to check
     * @returns `true` if the mesh is `MmdStaticMesh`
     */
    function isMmdStaticMesh(mesh) {
        if (mesh.metadata === null || !mesh.metadata.isMmdModel)
            return false;
        if (mesh.material === null || !mesh.material.subMaterials)
            return false;
        for (const material of mesh.material.subMaterials) {
            if (material === null)
                return false;
        }
        return true;
    }
    MmdMesh.isMmdStaticMesh = isMmdStaticMesh;
})(MmdMesh || (MmdMesh = {}));
export var HumanoidMesh;
(function (HumanoidMesh) {
    /**
     * Check if the mesh is humanoid mesh
     * @param mesh Mesh to check
     * @returns `true` if the mesh is `HumanoidMesh`
     */
    function isHumanoidMesh(mesh) {
        if (mesh.metadata === null || !mesh.metadata.isMmdModel)
            return false;
        if (mesh.material === null)
            return false;
        if (mesh.skeleton === null)
            return false;
        return true;
    }
    HumanoidMesh.isHumanoidMesh = isHumanoidMesh;
})(HumanoidMesh || (HumanoidMesh = {}));
